import { handleResponse, handleError, headerset } from "../apiUtils";
import { Previsione } from "components/main/pianificazione/previsioni/previsioniSlice";
import { FiltriPrevisioni } from "components/userPreference/userPreferenceSlice";

// ============================================
// BASE URL
// ============================================

const baseUrl = (previsione_id?: number | null) => {
    let url: string = process.env.API_URL + "/api/pianificazione/previsioni/";

    if (previsione_id) {
        url += previsione_id + "/";
    }

    return url;
};

// ============================================
// QUERY STRING BUILDER
// ============================================

const buildQueryString = (filtri: FiltriPrevisioni): string => {
    const params = new URLSearchParams();

    // ========== FILTRI SPECIFICI ==========

    // Filtro mandatario (singolo)
    if (filtri.mandatario) {
        params.append('mandatario', filtri.mandatario.toString());
    }

    // Filtro brand (singolo)
    if (filtri.brand) {
        params.append('brand', filtri.brand.toString());
    }

    // Filtro confezionista (singolo)
    if (filtri.confezionista) {
        params.append('confezionista', filtri.confezionista.toString());
    }

    // Filtro stagione (singolo)
    if (filtri.stagione) {
        params.append('stagione', filtri.stagione.toString());
    }

    // Filtro commerciale (singolo)
    if (filtri.commerciale) {
        params.append('commerciale', filtri.commerciale.toString());
    }

    // Filtro tecnica (array multiplo)
    if (filtri.tecnica && filtri.tecnica.length > 0) {
        params.append('tecnica', filtri.tecnica.join(','));
    }

    // Filtro fase_collezione (array multiplo)
    if (filtri.fase_collezione && filtri.fase_collezione.length > 0) {
        params.append('fase_collezione', filtri.fase_collezione.join(','));
    }

    // ========== PAGINAZIONE E RICERCA (sempre presenti) ==========
    if (filtri.page) {
        params.append('page', filtri.page.toString());
    }
    if (filtri.numero_record) {
        params.append('numero_record', filtri.numero_record.toString());
    }
    if (filtri.search) {
        params.append('search', filtri.search);
    }
    if (filtri.tutti) {
        params.append('tutti', 'true');
    }

    // Ordinamento se presente
    if (filtri.ordinamento) {
        params.append('ordinamento', filtri.ordinamento.toString());
    }

    return params.toString();
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch lista paginata di previsioni
 */
export function fetchPrevisioni(filtri: FiltriPrevisioni = {}) {
    let url = baseUrl();
    const queryString = buildQueryString(filtri);
    if (queryString) {
        url += `?${queryString}`;
    }

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Get singola previsione by ID
 */
export function getPrevisione(previsione_id: number) {
    const url = baseUrl(previsione_id);

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Save (create/update) previsione
 */
export function savePrevisione(previsioneToSave: Previsione, azione?:string ) {
    // Prepara i dati per l'invio
    const dataToSend = {
        ...previsioneToSave,
        // Assicurati che i decimali siano numeri o null
        px_prod: previsioneToSave.px_prod ? parseFloat(previsioneToSave.px_prod.toString()) : null,
        impianto: previsioneToSave.impianto ? parseFloat(previsioneToSave.impianto.toString()) : null,
        px_camp: previsioneToSave.px_camp ? parseFloat(previsioneToSave.px_camp.toString()) : null,
        qta_bdg: previsioneToSave.qta_bdg ? parseFloat(previsioneToSave.qta_bdg.toString()) : null,
        brand: previsioneToSave.brand ? previsioneToSave.brand : null,
        confezionista: previsioneToSave.confezionista ? previsioneToSave.confezionista : null,
        tecnica: previsioneToSave.tecnica ? previsioneToSave.tecnica : null,
    };
        let url = baseUrl(previsioneToSave.id);
        if (azione) {
            const separator = url.includes('?') ? '&' : '?';
            url += `${separator}azione=${azione}`;
        }
    return fetch(url, {
        method: previsioneToSave.id ? "PUT" : "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
        body: JSON.stringify(dataToSend),
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Delete previsione
 */
export function deletePrevisione(previsioneToDelete: Previsione) {
    return fetch(baseUrl(previsioneToDelete.id), {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}